PJQ.views.invoicing.InvoicePaymentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-invoice-payment-edit'),
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop(),
        isPayable: false
    },
    events: {
        'click .btn-view-invoice': 'viewInvoice',
        'click .btn-delete': 'delete',
        'click .btn-close': 'close',
        'click .btn-sync-erp': 'syncERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-save': 'savePayment',
        'click .btn-export': 'exportPayment'
    },
    beforeModalCreated: function () {
        if(this.options.isPayable) {
            this.options.canViewInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canView');
            this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('payableInvoices.isAdmin');
        }
        else{
            this.options.canViewInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.canView');
            this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin');
        }

        this.options.canEdit = this.options.isAdmin;
        this.options.canDelete = this.options.isAdmin;

        this.isFetched = false;
        PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
            this.erpIntegration = erp;

            if (this.model == null) {
                if(this.options.isPayable) {
                    this.model = new PJQ.models.invoicing.PayableInvoicePayment({
                        notes: '',
                        number: '',
                        invoiceId: this.options.invoice.id,
                        invoiceNumber: this.options.invoice.get('number'),
                        projectId: this.options.invoice.get('projectId'),
                        companyId: this.options.invoice.get('companyId'),
                        contractedContact: this.options.invoice.contractedContact,
                        contractedContactId: this.options.invoice.contractedContact ? this.options.invoice.contractedContact.id : null
                    });
                }
                else {
                    this.model = new PJQ.models.invoicing.ReceivableInvoicePayment({
                        notes: '',
                        number: '',
                        invoiceId: this.options.invoice.id,
                        invoiceNumber: this.options.invoice.get('number'),
                        projectId: this.options.invoice.get('projectId'),
                        companyId: this.options.invoice.get('companyId'),
                        client: this.options.invoice.client,
                        clientId: this.options.invoice.client ? this.options.invoice.client.id : null
                    });
                }
            }

            let fnRender = _.bind(function () {
                this.isFetched = true;
                this.render();
            }, this)
            if (!this.model.isNew()) {
                this.model.fetch({
                    success: fnRender
                });
            } else {
                fnRender();
            }
        }, this));
    },
    beforeRender: function () {
        if (this.model != null && !this.model.isNew()) {
            if (this.model.isERPSynced()) {
                this.options.canEdit = false;
                this.options.canDelete = false;
            } else {
                this.options.canEdit = this.options.isAdmin;
                this.options.canDelete = this.options.isAdmin;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewInvoices: this.options.canViewInvoices,
            isPayable: this.options.isPayable,
            canViewCommitments: this.options.canViewCommitments,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);

        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.payment-client'),
            selectedContact: this.options.isPayable ? this.model.contractedContact : this.model.client,
            canEdit: false,
            displayContactsBlock: true,
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-payment-method'),
            defaultValue: this.model.get('paymentMethod'),
            canEdit: this.options.canEdit,
            onChange: _.bind(function (value) {
                this.model.set('paymentMethod', value);
            }, this)
        });

        this.dateReceivedPicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-date-received'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dateReceived') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('dateReceived'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dateReceived', newDate);
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.payment-file-uploader'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            useApiV2: true,
            canDelete: this.options.canEdit && this.options.isAdmin,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    viewInvoice: function () {
        this.removeModal();
        if(this.options.isPayable){
            new PJQ.views.invoicing.EditPayableInvoiceModal({
                model: new PJQ.models.invoicing.PayableInvoice({
                    id: this.model.get('invoiceId')
                })
            });
        }
        else {
            new PJQ.views.invoicing.EditReceivableInvoiceModal({
                model: new PJQ.models.invoicing.ReceivableInvoice({
                    id: this.model.get('invoiceId')
                })
            });
        }
    },
    viewPrimeContract: function () {
        this.removeModal();
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            })
        });
    },
    viewCommitment: function () {
        this.removeModal();
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: this.model.get('commitmentId')
            })
        });
    },
    syncERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.syncERP(_.bind(function () {
                if (this.model.isERPSynced()) {
                    this.render();
                } else {
                    loader.remove();
                }
            }, this));
        }
    },
    unlinkERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.unlinkERP(_.bind(function (success, error) {
                if (success) {
                    this.render();
                } else {
                    let errMsg;
                    if (error === 'LINKED_OBJECT_EXISTS') {
                        errMsg = 'You cannot unlink this payment until it is deleted from your ERP system';
                    } else {
                        errMsg = 'An error occurred when attempting to unlink this payment.  Please contact customer service.';
                    }
                    PJQ.notifications.notify.errorNotify({
                        title: 'Payment Still Exists!',
                        message: errMsg
                    });
                    loader.remove();
                }
            }, this));
        }
    },
    exportPayment: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: this.options.isPayable ? 'payableinvoicepayments' : 'receivableinvoicepayments',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        }, this);

        this.save(callback, true);
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this Payment?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Payment successfully deleted'
                        });
                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    savePayment: function () {
        let isNew = this.model.isNew();
        this.model.save(null, {
            success: _.bind(function () {
                if (isNew) {
                    this.model.dirtyAttributes = {};
                    PJQ.notifications.notify.successNotify({
                        message: 'Payment created successfully'
                    });

                    if (typeof this.options.onSave === 'function')
                        this.options.onSave(this.model, isNew);

                    this.render();
                } else {
                    PJQ.notifications.notify.successNotify({
                        message: 'Payment saved successfully'
                    });

                    if (typeof this.options.onSave === 'function')
                        this.options.onSave(this.model, isNew);

                    this.removeModal();
                }
            }, this)
        });
    },
    validate: function () {
        return true;
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Payment has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Payment",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Payment email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.savePayment();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});